export const colors = {
  tooltipLine: '#6A7692',
  dot: '#0B2140',
  dotStroke: 'white',
  backgroundLine: '#D9D9D9',
  axisTickLabel: '#6A7692',
  primary: '#627EEA',
  secondary: '#F2A52B',
}

const colorsPalette = [
  '#A451E6', // purple
  '#75D78E', // light green
  '#E91E63', // magenta
  '#FF895D', // orange
  '#F7C52D', // yellow
  '#FC8787', // coral/pink
  '#908E9E', // gray
  '#4A90E2', // blue
  '#24C84E', // bright green
  '#1ABC9C', // teal
  '#E74C3C', // red
  '#FF9800', // amber
  '#E67E22', // darker orange
  '#3498DB', // lighter blue
  '#795548', // brown
  '#607D8B', // blue gray
]

export function getPaletteColor(itemIndex: number): string {
  return colorsPalette[itemIndex % colorsPalette.length]!
}
